/**
 * Slot Check Search drawer layout (pure, unit-tested).
 *
 * The drawer panel is translated down by translateY, so the visible part is
 * vh - translateY. The scroll list must fit inside that, minus everything above
 * it in the panel (handle + header, measured as chromePx). The list's own
 * bottom padding (CSS, incl. the iOS safe-area inset) keeps the last card clear
 * of the home indicator.
 */
export const DRAWER_LIST_MIN_PX = 120;

export function drawerContentMaxHeight(vh: number, translateY: number, chromePx: number): number {
  const v = Number.isFinite(vh) ? vh : 0;
  const y = Number.isFinite(translateY) ? translateY : 0;
  const c = Number.isFinite(chromePx) && chromePx > 0 ? chromePx : 0;
  return Math.max(DRAWER_LIST_MIN_PX, Math.round(v - y - c));
}
